import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { saveUser } from '../../../store/actions/admin';

import { Card } from 'reactstrap';
import DataTable from 'react-data-table-component';
import { ChevronDown } from 'react-feather';
import { Box } from '@mui/material';

import { columns } from './adnimAccessColumns';

const AdminAccess = () => {
    const { users } = useSelector((state) => state.admin);
    const dispatch = useDispatch();

    const dataToRender = () => {
        if (!users) {
            return [];
        } else {
            return users.map((user) => {
                return {
                    ...user,
                    setAdmin: (value) =>
                        dispatch(saveUser({ ...user, isAdmin: value })),
                };
            });
        }
    };

    return (
        <Box sx={{ flexBasis: '75%' }}>
            <Card className="overflow-hidden">
                <div className="react-dataTable">
                    <DataTable
                        noHeader
                        responsive
                        columns={columns}
                        sortIcon={<ChevronDown />}
                        highlightOnHover
                        pointerOnHover
                        className="react-dataTable"
                        data={dataToRender()}
                    />
                </div>
            </Card>
        </Box>
    );
};
export default AdminAccess;
